import { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { zendesk } from 'bv-services';
import classnames from 'classnames';
import { compose } from 'underscore';
import { t } from 'bv-i18n';
import Icon from '../icon';
import liveChatStore, { fetchSettingsThunk } from './ducks';

const { addReducers } = window.reduxState;

addReducers({ liveChatStore });

const LiveChat = ({
  className, card, fetchSettings, settings, loaded, loading, location,
}) => {
  useEffect(() => {
    if (!loaded && !loading) fetchSettings();
  }, []);

  if (!loaded) return null;

  const locationSetting = settings.find((setting) => setting.location === location);
  if (locationSetting && locationSetting.enabled === false) return null;

  return (
    <div className={classnames(className, {
      'bvs-card': !!card,
    })}
    >
      {t('javascript.quick_chat.need_help')}
      <span
        className="bvs-text-brand"
        onClick={zendesk.liveChat}
      >
        {t('javascript.quick_chat.live_chat')}
      </span>
      <Icon
        id="live-chat"
        onClick={zendesk.liveChat}
      />
    </div>
  );
};

LiveChat.propTypes = {
  className: PropTypes.string,
  card: PropTypes.bool,
  fetchSettings: PropTypes.func.isRequired,
  settings: PropTypes.arrayOf(Object).isRequired,
  loaded: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.string,
};

LiveChat.defaultProps = {
  className: '',
  card: false,
  location: '',
};

const mapStateToProps = (state) => state.liveChatStore;

const mapDispatchToProps = (dispatch) => ({
  fetchSettings: compose(dispatch, fetchSettingsThunk),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiveChat);
